import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import "./Cgu.css";
import Header from '../header/header';
import Footer from '../commun/Footer';

const CGU = () => (
    <>

    < Header />
  <Container maxWidth="md" className="cgu-container">
    <Box py={5}>
      <Typography variant="h4" align="center" gutterBottom>
        Conditions Générales d’Utilisation (CGU)
      </Typography>

      <Typography
        variant="subtitle2"
        align="center"
        className="cgu-date"
        gutterBottom
      >
        Dernière mise à jour : [25/06/2025]
      </Typography>

      <Divider className="cgu-divider" />

      <Typography variant="h6" gutterBottom>1. Objet des CGU</Typography>
      <Typography paragraph>
        Les présentes Conditions Générales d’Utilisation ont pour objet de définir les modalités d’accès et d’utilisation du site www.cooptaleo.com, plateforme de mise en relation entre entreprises, recruteurs indépendants et talents IT, éditée par CIT MENA INFORMATION TECHNOLOGY CONSULTANCY (ci-après « l’Éditeur »).
      </Typography>

      <Typography variant="h6" gutterBottom>2. Accès au site</Typography>
      <Typography paragraph>
        Le site est accessible gratuitement à tout utilisateur disposant d’un accès à internet. Certains services nécessitent une inscription et la création d’un compte (entreprise, recruteur ou candidat).
      </Typography>
      <Typography paragraph>
        L’utilisateur s’engage à fournir des informations exactes lors de son inscription.
      </Typography>

      <Typography variant="h6" gutterBottom>3. Description des services</Typography>
      <Typography paragraph>
        Cooptaleo propose notamment :
      </Typography>
      <ul className="cgu-list">
        <li>Aux entreprises : publication de besoins, consultation de profils, gestion de candidatures, suivi des performances.</li>
        <li>Aux recruteurs : accès à des missions, dépôt de profils, suivi des primes.</li>
        <li>Aux candidats : dépôt de CV, mise en relation avec des recruteurs, gestion de leur profil.</li>
      </ul>
      <Typography paragraph>
        Certains services peuvent être restreints selon le type de compte.
      </Typography>

      <Typography variant="h6" gutterBottom>4. Engagements de l’utilisateur</Typography>
      <Typography paragraph>
        L’utilisateur s’engage à :
      </Typography>
      <ul className="cgu-list">
        <li>Utiliser le site dans le respect des lois et règlements en vigueur</li>
        <li>Ne pas usurper l’identité d’un tiers</li>
        <li>Ne pas diffuser de contenus illicites, offensants ou diffamatoires</li>
        <li>Ne pas utiliser le site à des fins commerciales non autorisées</li>
      </ul>

      <Typography variant="h6" gutterBottom>5. Responsabilité</Typography>
      <Typography paragraph>
        L’Éditeur met tout en œuvre pour assurer le bon fonctionnement du site. Toutefois, sa responsabilité ne saurait être engagée en cas :
      </Typography>
      <ul className="cgu-list">
        <li>D’indisponibilité temporaire ou interruption pour maintenance</li>
        <li>D’anomalies techniques indépendantes de sa volonté</li>
        <li>D’utilisation frauduleuse ou abusive du site par un utilisateur</li>
      </ul>

      <Typography variant="h6" gutterBottom>6. Données personnelles</Typography>
      <Typography paragraph>
        Le traitement des données personnelles est détaillé dans notre Politique de confidentialité. L’utilisateur dispose des droits d’accès, de rectification et de suppression de ses données.
      </Typography>

      <Typography variant="h6" gutterBottom>7. Propriété intellectuelle</Typography>
      <Typography paragraph>
        Tous les contenus du site (logos, textes, visuels, éléments techniques…) sont protégés par le droit d’auteur. Toute reproduction totale ou partielle est interdite sans autorisation écrite préalable.
      </Typography>

      <Typography variant="h6" gutterBottom>8. Liens externes</Typography>
      <Typography paragraph>
        Le site peut contenir des liens vers d’autres sites. L’Éditeur ne peut être tenu responsable de leur contenu.
      </Typography>

      <Typography variant="h6" gutterBottom>9. Modification des CGU</Typography>
      <Typography paragraph>
        Cooptaleo se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés des modifications lors de leur prochaine connexion.
      </Typography>

      <Typography variant="h6" gutterBottom>10. Droit applicable – Juridiction compétente</Typography>
      <Typography paragraph>
        Les présentes CGU sont régies par le droit des Émirats arabes unis. En cas de litige, les tribunaux compétents seront ceux du ressort du siège social de l’Éditeur, sauf dispositions légales impératives contraires.
      </Typography>
    </Box>
  </Container>
<Footer />

  </>
);

export default CGU;
